import { RetorikConfiguration } from '../configs/retorikConfig';
const changeBackground : Function = (config : RetorikConfiguration) => {
    let changedConfig = {...config}

    return changedConfig;
}

const changeLogo : Function = (url : string, config : RetorikConfiguration) => {
    let changedConfig = {...config}
    if(changedConfig && changedConfig.config && changedConfig.config.logo){
        changedConfig.config.logo.src = url
    }
    return changedConfig;
}

const changeAnimation : Function = (animation : Animation) => {

}

const changeDisposition : Function = () => {
    
}

const changeGender : Function = (gender : string, config : RetorikConfiguration) => {
    let changedConfig : RetorikConfiguration = {...config}
    let mainContainer = document.getElementById("retorik-container");
    if(gender == "male"){
        changedConfig.agentData = "/videos/enseignant_smile";
        changedConfig.config.mainframe.chosenBackground = "image";
        changedConfig.config.mainframe.background.image = 'images/background_enseignant.jpg';
        changedConfig.chatbotData.size = undefined;
        if(mainContainer){
            mainContainer.classList.remove("patienteDisplay");
        }
    }
    else if (gender == "female"){
        changedConfig.agentData = `/videos/patiente`;
        changedConfig.config.mainframe.chosenBackground = "image";
        changedConfig.config.mainframe.background.image = 'images/background_patiente_large_2.png';
        changedConfig.chatbotData.size = undefined;
        if(mainContainer){
            mainContainer.classList.add("patienteDisplay");
        }
    }
    return changedConfig;
}


const changeVoice : Function = (gender : any | undefined  ,voice : string | undefined, config : RetorikConfiguration) => {
    let changedConfig : RetorikConfiguration = {...config}
    if(voice){
        changedConfig.customVoice = {
            voice: voice
          }
    }
    else if(gender){
        changedConfig.customVoice = {
            gender: gender
          }
    }
    
    return changedConfig;
}

const toggleSubtitles : Function = (config : RetorikConfiguration, enable : boolean) => {
    let changedConfig : RetorikConfiguration = {...config}
    changedConfig.config.subtitles.activated = enable ? true : false;
    return changedConfig;
}

export {
    changeBackground,
    changeLogo,
    changeGender,
    toggleSubtitles,
    changeVoice
}